export default "__VITE_ASSET__CYhW7hwz__"